import {Component, effect, input, model, output, ChangeDetectionStrategy} from "@angular/core"
import {FormsModule} from "@angular/forms"
import {MatInputModule} from "@angular/material/input"
import {colorToString, parseColor} from "@cm/utils"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-color-input",
    templateUrl: "./color-input.component.html",
    styleUrls: ["./color-input.component.scss"],
    imports: [FormsModule, MatInputModule],
})
export class ColorInputComponent {
    readonly $label = input<string>(undefined, {alias: "label"})
    readonly $value = input<[number, number, number]>(undefined, {alias: "value"})
    readonly $hexValue = model("#ffffff", {alias: "hexValue"})

    constructor() {
        effect(() => {
            const tupleValue = this.$value()
            if (tupleValue !== undefined) {
                this.$hexValue.set(colorToString(tupleValue))
            }
        })
    }

    changeValue(value: string) {
        this.$hexValue.set(value)
        this.hexValueChange.emit(this.$hexValue())
        this.valueChange.emit(parseColor(this.$hexValue()))
    }

    onFocus() {
        this.isPopupOpen.emit(true)
    }

    onBlur() {
        this.isPopupOpen.emit(false)
    }

    readonly hexValueChange = output<string>()
    readonly valueChange = output<[number, number, number]>()
    readonly isPopupOpen = output<boolean>()
}
